<template>
  <Modal title="上课反馈" v-model="visible">
    <Form ref="recordForm" class="form" 
      :model="recordParam" :rules="recordRule"
      :label-width="120">
      <Row>
        <Col :span="22">
          <Form-item label="学生ID、姓名：">
            <label>{{ studentName }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="老师ID、姓名：">
            <label>{{ teacherName }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="上课时间：">
            <label>{{ lessonTime }}</label>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="上课反馈" prop="feedContent">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="recordParam.feedContent" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AddLessonFeedbackModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      studentName: {
        type: String
      },
      teacherName: {
        type: String
      },
      lessonTime: {
        type: String
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        recordParam: {
          feedContent: '',
        },
        loadingAdd: false,
        recordRule: {
          feedContent: [
            { type: 'string', required: true, message: '请填写上课反馈', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      add () {
        let self = this
        self.loadingAdd = true
        self.$refs.recordForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.recordParam.bookLessonOpenedId = self.openedId
          self.$http.post('/stageReport/fm-message-book-lesson-add', self.recordParam).then(function (res) {
            self.loadingAdd = false
            if (res) {
              self.$Message.success('添加成功!')
              self.visible = false
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.recordParam.feedContent = ''
        }
        this.$emit('input', val)
      }
    }
  }  
</script>



// WEBPACK FOOTER //
// AddLessonFeedbackModal.vue?4a6129c0